module.exports = __webpack_public_path__ + "static/media/whisky.327da1bd.svg";